/**
 * EVM token types
 */

import { EvmAddress, PendulumTokenDetails } from "../..";
import { Networks } from "../../helpers";
import { BaseTokenDetails, TokenType } from "./base";

export enum EvmToken {
  AXLUSDC = "AXLUSDC",
  USDC = "USDC",
  USDT = "USDT",
  USDCE = "USDC.E",
  ETH = "ETH",
  BRLA = "BRLA",
  EURC = "EURC",
  MORPHO_VAULT = "VAULT"
}

export enum UsdLikeEvmToken {
  USDC = EvmToken.USDC,
  USDT = EvmToken.USDT,
  USDCE = EvmToken.USDCE
}

export interface EvmTokenDetails extends BaseTokenDetails {
  type: TokenType.Evm;
  assetSymbol: string;
  network: Networks;
  erc20AddressSourceChain: EvmAddress;
  isNative: boolean;
  /// The metadata about the token when it's used in Pendulum.
  /// For now, all EVM tokens are represented by axlUSDC on Pendulum.
  pendulumRepresentative: PendulumTokenDetails;
  /// URL to the token's logo image from external sources (e.g., Squid Router)
  logoURI?: string;
  /// Fallback URL for the token's logo image (constructed from chainId and address)
  fallbackLogoURI?: string;
  usdPrice?: number;
  /// True for tokens defined in the static evmTokenConfig (used for sorting priority)
  isFromStaticConfig?: boolean;
}

export interface EvmTokenDetailsWithBalance extends EvmTokenDetails {
  balance: string;
  balanceUsd: string;
}
